export const buildTrialInfoOrUndefined = (data) => {
    var _a, _b, _c, _d, _e, _f, _g;
    if (!data)
        return undefined;
    const trialInfo = {
        planInterval: (_a = data.planInterval) !== null && _a !== void 0 ? _a : '',
        trialStartDate: (_b = data.trialStartDate) !== null && _b !== void 0 ? _b : 0,
        trialDaysRemaining: (_c = data.trialDaysRemaining) !== null && _c !== void 0 ? _c : 0,
        planId: (_d = data.planId) !== null && _d !== void 0 ? _d : 'FREE_2016',
        seats: (_e = data.seats) !== null && _e !== void 0 ? _e : 0,
        paidCustomerInPast: (_f = data.paidCustomerInPast) !== null && _f !== void 0 ? _f : false,
        trialEndDate: (_g = data.trialEndDate) !== null && _g !== void 0 ? _g : 0,
    };
    return trialInfo;
};
